import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CommonFunctionsService } from '../_services/commonFunctions.service';
import { NgxToasterService } from '../_services/toastr.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Directive({
  selector: 'img[signedImageSrc]',
    providers: [

      CommonFunctionsService,

    ],
})
export class SignedImageDirective implements OnInit{
  private ngUnsubscribe: Subject<void> = new Subject<void>();
    @Input() signedImageSrc: any;

    constructor(private elementRef: ElementRef,     private toasterNotification: NgxToasterService,   public commonFunctionsService: CommonFunctionsService,
         private renderer: Renderer2,private http: HttpClient) {}

    ngOnInit() {
        this.commonFunctionsService
        .generatesignedUrl({ file_name: this.signedImageSrc })
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response: any) => {
          if (response.status === environment.SUCCESS_STATUS) {
            console.log(response.url,"respppppppp");
            this.renderer.setProperty(this.elementRef.nativeElement, 'src', response.url);
          } else {
            this.toasterNotification.showError(response.message);
          }
        });

        // (async () => {
          
        //     let imgRes:any = await this.http.get(`${environment.SIGNED_API}/signurl?domain=${environment.PROFILE_BASE_URL}&key=${this.signedImageSrc}`, {
        //         headers: new HttpHeaders()
        //             .set('x-api-key', environment.AWS_API_KEY)
        //             .set('authExempt', 'true')
        //         }).toPromise();
        //     console.log('Loadeddddd',this.signedImageSrc, imgRes)
        //    this.renderer.setProperty(this.elementRef.nativeElement, 'src', imgRes?.body?.url);
        // })();
        
    }

}